export default __webpack_public_path__ + "static/media/871.652821d9.png";